import { Grid } from '@mui/material';
import { useState, useEffect } from 'react';
import {
  ICalendarAccount,
  IOutlookCalendarAccount,
  getCalendarAccounts,
  getOutlookCalendarAccounts,
} from 'wisestep-api';

import { INotification, useNotificationStore } from '../../../utils/NotificationStore';

import CalendarBoard from './CalendarBoard';
import TaskBoard from './TaskBoard';

const ReminderBoard = () => {
  const [calendarEventAccountGoogle, setCalendarEventAccountGoogle] =
    useState<ICalendarAccount | null>(null);
  const [calendarEventAccountOutlook, setCalendarEventAccountOutlook] =
    useState<IOutlookCalendarAccount | null>(null);
  const setNotification = useNotificationStore((state) => state.setNotification);

  useEffect(() => {
    (async () => {
      const errorObj: INotification = {
        type: 'error',
        message: 'Error in fetching calendar accounts',
      };
      try {
        const googleCalendarAcc = await getCalendarAccounts();
        setCalendarEventAccountGoogle(googleCalendarAcc.data[0] ?? null);
      } catch (e) {
        setNotification(errorObj);
      }
      try {
        const outlookCalendarAccount = await getOutlookCalendarAccounts();
        setCalendarEventAccountOutlook(outlookCalendarAccount.data[0] ?? null);
      } catch (e) {
        setNotification(errorObj);
      }
    })();
  }, [setNotification]);
  return (
    <Grid container spacing={2}>
      <Grid item md={6} sm={12} xs={12}>
        <TaskBoard
          calendarEventAccountGoogle={calendarEventAccountGoogle as ICalendarAccount | undefined}
          calendarEventAccountOutlook={
            calendarEventAccountOutlook as IOutlookCalendarAccount | undefined
          }
        />
      </Grid>
      <Grid item md={6} sm={12} xs={12}>
        <CalendarBoard
          calendarEventAccountGoogle={calendarEventAccountGoogle}
          calendarEventAccountOutlook={calendarEventAccountOutlook}
        />
      </Grid>
    </Grid>
  );
};

export default ReminderBoard;
